import type { CarPark } from "@/hooks/useCarParks"

export const UNKNOWN_DEPOT = "Unknown depot"

export function formatClockInLocation(depotName: string | null, carPark: CarPark | null): string {
  const depot = depotName ?? UNKNOWN_DEPOT
  if (!carPark) return depot

  return `${depot} (${carPark.address ?? carPark.name})`
}
